import { render, staticRenderFns } from "./SignForm.vue?vue&type=template&id=34f4ad38&scoped=true&"
import script from "./SignForm.vue?vue&type=script&lang=ts&"
export * from "./SignForm.vue?vue&type=script&lang=ts&"
import style0 from "./SignForm.vue?vue&type=style&index=0&id=34f4ad38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4ad38",
  null
  
)

export default component.exports